import insights from "./../assets/analytics.svg";
import whiteInsights from "./../assets/analytics white.svg";
import assets from "./../assets/asset-tracking.svg";
import whiteAssets from "./../assets/asset-tracking white.svg";
import devices from "./../assets/technology.svg";
import whiteDevices from "./../assets/technology white.svg";
import alarms from "./../assets/error.svg";
import whiteAlarms from "./../assets/error white.svg";
import location from "./../assets/location.svg";
import whiteLocation from "./../assets/location white.svg";
import organizations from "./../assets/medium-business.svg";
import whiteOrganizations from "./../assets/medium-business white.svg";
import users from "./../assets/Users.svg";
import whiteUsers from "./../assets/Users white.svg";
import roles from "./../assets/Roles.svg";
import whiteRoles from "./../assets/Roles white.svg";
import whiteShipment from "./../assets/shipping_white.svg";
import Shipment from "./../assets/shipping.svg";
import Deviceprofile from "./../assets/Deviceprofile.svg";
import SupportIcon from "./../assets/support.svg";


export const menuList = {
  Manage: [
    {
      name: "Insights",
      path: "/insights",
      selector: "insights",
      whiteIcon: whiteInsights,
      blackIcon: insights,
    },
    {
      name: "Shipments",
      path: "/shipments",
      selector: "shipments",
      whiteIcon: whiteShipment,
      blackIcon: Shipment,
    },
    {
      name: "Assets",
      path: "/assets",
      selector: "assets",
      whiteIcon: whiteAssets,
      blackIcon: assets,
    },
    {
      name: "Devices",
      path: "/devices",
      selector: "devices",
      whiteIcon: whiteDevices,
      blackIcon: devices,
    },
    {
      name: "Device profile",
      path: "/device-profile",  
      selector: "devices", 
      whiteIcon: Deviceprofile,
      blackIcon: devices,
    },
    {
      name: "Alerts",
      path: "/alerts",
      selector: "alarms",
      whiteIcon: whiteAlarms,
      blackIcon: alarms,
    },
    {
      name: "Locations",
      path: "/locationdetails",
      selector: "Locations",
      whiteIcon: whiteLocation,
      blackIcon: location,
    },
    {
      name: "Organizations",
      path: "/organization",
      selector: "organizations",
      whiteIcon: whiteOrganizations,
      blackIcon: organizations,
    },
    {
      name: "Users",
      path: "/users",
      selector: "users",
      whiteIcon: whiteUsers,
      blackIcon: users,
    },
    {
      name: "Roles",
      path: "/roles",
      selector: "roles",
      whiteIcon: whiteRoles,
      blackIcon: roles,
    },
    {
      name: "Support",
      path: "/support",
      whiteIcon: SupportIcon,
      blackIcon: SupportIcon,
      selector: "support",
    }
  ],
};
